import axios from '../utils/axios';

export default function updateNTCPremiumJobRejectionTags(adminId, id, data) {
    return axios.post(`/admin/${adminId}/ntc-premium-jobs/${id}/rejection-tags`, data)
        .then(res => res.data)
        .catch(err => err);
}
